import React, { useRef } from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Stack, Typography } from '@mui/material';

/**
 * The one edit form for a settings item: a title, its fields, Cancel and
 * Save. Enter in a single-line field saves; the first field is focused.
 */
const SettingsDialog: React.FC<{
  open: boolean;
  title: string;
  subtitle?: string;
  onClose: () => void;
  onSave: () => void;
  saving: boolean;
  saveLabel?: string;
  saveDisabled?: boolean;
  children: React.ReactNode;
}> = ({ open, title, subtitle, onClose, onSave, saving, saveLabel = 'Save', saveDisabled, children }) => {
  const body = useRef<HTMLFormElement>(null);
  return (
    <Dialog
      open={open}
      onClose={saving ? undefined : onClose}
      maxWidth="sm"
      fullWidth
      TransitionProps={{ onEntered: () => body.current?.querySelector<HTMLInputElement>('input, textarea')?.focus() }}
    >
      <DialogTitle component="div" sx={{ pb: 0.5 }}>
        <Typography variant="h6" fontWeight={700}>{title}</Typography>
        {subtitle && <Typography variant="body2" color="text.secondary">{subtitle}</Typography>}
      </DialogTitle>
      <DialogContent sx={{ pt: '16px !important' }}>
        <Stack
          ref={body}
          component="form"
          spacing={2.5}
          noValidate
          onSubmit={e => { e.preventDefault(); if (!saving && !saveDisabled) onSave(); }}
        >
          {children}
          {/* Lets Enter submit the form. */}
          <button type="submit" hidden aria-hidden />
        </Stack>
      </DialogContent>
      <DialogActions sx={{ px: 3, py: 2 }}>
        <Button onClick={onClose} color="inherit" disabled={saving}>Cancel</Button>
        <Button variant="contained" disableElevation onClick={onSave} disabled={saving || saveDisabled}>
          {saving ? 'Saving…' : saveLabel}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default SettingsDialog;
